<mat-card class="card-box mat-elevation-z4">
    <mat-spinner></mat-spinner>
</mat-card>
